import {
  BulletedListIcon,
  CheckBoxIcon,
  CodeBlockIcon,
  DividerIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  NumberedListIcon,
  QuoteIcon,
  TextIcon,
} from '@blocksuite/affine-components/icons';
import type { NoteChildrenFlavour } from '@blocksuite/affine-shared/types';
import type { TemplateResult } from 'lit';

export const BUTTON_GROUP_LENGTH = 10;

export type NoteMenuItem = {
  icon: TemplateResult<1>;
  tooltip: string;
  childFlavour: NoteChildrenFlavour;
  childType: string | null;
};

const LIST_ITEMS = [
  {
    flavour: 'affine:list',
    type: 'bulleted',
    name: '项目列表',
    description: '简单的项目列表。',
    icon: BulletedListIcon,
    tooltip: '拖动或点击插入项目列表',
  },
  {
    flavour: 'affine:list',
    type: 'numbered',
    name: '编号列表',
    description: '带有编号的列表。',
    icon: NumberedListIcon,
    tooltip: '拖动或点击插入编号列表',
  },
  {
    flavour: 'affine:list',
    type: 'todo',
    name: '待办列表',
    description: '使用待办列表跟踪任务。',
    icon: CheckBoxIcon,
    tooltip: '拖动或点击插入待办列表',
  },
];

const TEXT_ITEMS = [
  {
    flavour: 'affine:paragraph',
    type: 'text',
    name: '文本',
    description: '开始输入文本。',
    icon: TextIcon,
    tooltip: '拖动或点击插入文本块',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h1',
    name: '一级标题',
    description: '使用最大字号的标题。',
    icon: Heading1Icon,
    tooltip: '拖动或点击插入一级标题',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h2',
    name: '二级标题',
    description: '使用第二级字号的标题。',
    icon: Heading2Icon,
    tooltip: '拖动或点击插入二级标题',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h3',
    name: '三级标题',
    description: '使用第三级字号的标题。',
    icon: Heading3Icon,
    tooltip: '拖动或点击插入三级标题',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h4',
    name: '四级标题',
    description: '使用第四级字号的标题。',
    icon: Heading4Icon,
    tooltip: '拖动或点击插入四级标题',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h5',
    name: '五级标题',
    description: '使用第五级字号的标题。',
    icon: Heading5Icon,
    tooltip: '拖动或点击插入五级标题',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h6',
    name: '六级标题',
    description: '使用第六级字号的标题。',
    icon: Heading6Icon,
    tooltip: '拖动或点击插入六级标题',
  },
  {
    flavour: 'affine:code',
    type: 'code',
    name: '代码块',
    description: '记录代码片段。',
    icon: CodeBlockIcon,
    tooltip: '拖动或点击插入代码块',
  },
  {
    flavour: 'affine:paragraph',
    type: 'quote',
    name: '引用',
    description: '记录引用内容。',
    icon: QuoteIcon,
    tooltip: '拖动或点击插入引用',
  },
  {
    flavour: 'affine:divider',
    type: null,
    name: '分隔线',
    description: '用于区分内容的分隔线。',
    icon: DividerIcon,
    tooltip: '用于区分内容的分隔线',
  },
];

// TODO: add image, bookmark, database blocks
export const NOTE_MENU_ITEMS = TEXT_ITEMS.concat(LIST_ITEMS)
  .filter(item => item.flavour !== 'affine:divider')
  .map(item => {
    return {
      icon: item.icon,
      tooltip:
        item.type !== 'text'
          ? item.tooltip.replace('拖动或点击插入', '')
          : '文本',
      childFlavour: item.flavour as NoteChildrenFlavour,
      childType: item.type,
    } as NoteMenuItem;
  });
